import { InternalAxiosRequestConfig } from 'axios';

/**
 * Adds filter query parameter to url if it specified in axios request config
 * @param config
 * @returns
 */
export const queryParamsInterceptor: (config: InternalAxiosRequestConfig) => InternalAxiosRequestConfig = (config) => {
  if (!config.url || !config.filter) {
    return config;
  }

  if (config.filter) {
    if (!config.params) {
      config.params = {};
    }
    config.params.filter = JSON.stringify(config.filter);
  }

  return config;
};
